/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\BrandSVG\HYUNDAI.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 10th 2023 5:10:22 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function HYUNDAI(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M540.08,314.79c-243.06,0-440.12,100.82-440.12,225.45s197.06,225.32,440.12,225.32v.07c243.12,0,440.25-100.96,440.25-225.39s-197.13-225.45-440.25-225.45Zm-81.54,110.13h0c7.42-17,20.03-53.35,49.03-67.78,8.77-4.38,19.69-6.47,29.34-6.74h4.38c81.33,0,156.87,11.2,220.26,30.55,.47,.2,1.96,.67,2.43,.94,5.8,1.96,8.77,4.65,8.77,7.96,0,2.9-1.55,5.06-3.57,7.08-.94,.94-2.23,2.02-4.05,3.51-14.57,12.27-58.61,44.11-141.49,75.87-29.2,11.13-65.55,24.95-103.52,32.98-22.39,4.72-105.34,17.4-61.57-84.37Zm-223.77,227.54c-1.48,2.7-3.57,5.06-7.28,5.26-2.02,.2-4.92-.4-9.24-3.03-51.66-31.7-82.21-71.49-82.21-114.58,0-77.69,99.81-144.53,242.79-173.66v-.07c9.17-1.75,15.24-1.75,17.47,.54,1.35,1.48,1.69,3.91-.07,6.95-1.1,1.88-2.39,3.64-3.84,5.26-77.83,91.79-137.11,227.07-154.03,266.19-1.21,2.7-2.5,5.4-3.57,7.15Zm388.26,2.5c-7.42,17.06-20.03,53.41-49.03,67.91-9.24,4.22-19.25,6.51-29.4,6.74h-4.45c-81.2,0-156.87-11.33-220.13-30.55l-2.43-.94c-5.87-1.96-8.83-4.65-8.83-8.03,0-2.83,1.55-5.06,3.64-7.15l3.98-3.51c14.7-12.14,58.67-44.04,141.56-75.87,29.07-11.06,65.48-24.89,103.59-32.98,22.32-4.65,105.21-17.33,61.44,84.44l.07-.07Zm78.43,58.88c-9.17,1.82-15.31,1.75-17.33-.54-1.48-1.35-1.89-3.91,0-7.01,1.06-1.89,2.33-3.65,3.78-5.26,77.83-91.72,137.11-227.07,153.9-266.05,1.35-2.7,2.56-5.4,3.57-7.22h0c1.55-2.7,3.64-4.99,7.42-5.19,2.02-.2,4.86,.27,9.1,2.97,51.66,31.76,82.34,71.55,82.34,114.65,0,77.62-99.88,144.46-242.79,173.66Z"/>
        </svg>
    );
}

export default HYUNDAI;
